import { Navigate, Outlet } from "react-router-dom";


function PublicRoute() {
    return (localStorage.getItem("isLogged") === "false" || !localStorage.getItem("isLogged")) ? <Outlet /> : <Navigate to="/chat" replace />;

}

export default PublicRoute 